import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [intervalId, setIntervalId] = useState(null);

  const slides = [
    {
      id: 1,
      title: (
        <>
          40년의 경험,<br />
          품질로 증명합니다.
        </>
      ),
      backgroundImage: "/main/main1.jpg"
    },
    {
      id: 2,
      title: (
        <>
          100% 국내생산 및<br />
          국내 최대규모 생산능력 보유
        </>
      ),
      backgroundImage: "/main/main2.jpg"
    },
    {
      id: 3,
      title: (
        <>
          땀과 노력으로<br />
          고객만족을 실현합니다.
        </>
      ),
      backgroundImage: "/main/main3.JPG"
    },
    {
      id: 4,
      title: (
        <>
          소형 열교환기에서<br />
          대형 플랜트 설비까지
        </>
      ),
      backgroundImage: "/main/main4.jpg"
    },
    {
      id: 5,
      title: (
        <>
          지역난방설비의 선두주자,<br />
          태봉산업기술
        </>
      ),
      backgroundImage: "/main/main5.jpg"
    },
    {
      id: 6,
      title: (
        <>
          기술의 혁신에 책임을 더해,<br />
          지속 가능한 미래를 설계합니다.
        </>
      ),
      backgroundImage: "/main/main6.jpg"
    },
    {
      id: 7,
      title: (
        <>
          남부사업소<br />
          (포항공장)
        </>
      ),
      backgroundImage: "/main/main7.JPG"
    }
  ];

  // 자동 슬라이드 시작 함수
  const startAutoSlide = () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
    const newIntervalId = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // 5초마다 자동 슬라이드
    setIntervalId(newIntervalId);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    startAutoSlide(); // 타이머 초기화
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    startAutoSlide(); // 타이머 초기화
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    startAutoSlide(); // 타이머 초기화
  };

  // 자동 슬라이드 기능
  useEffect(() => {
    startAutoSlide();
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [slides.length]);


  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-slider">
          <div className="hero-slides" style={{ transform: `translateX(-${currentSlide * (100/7)}%)` }}>
            {slides.map((slide) => (
              <div key={slide.id} className="hero-slide" style={{ backgroundImage: `url(${slide.backgroundImage})` }}>
                <div className="hero-overlay"></div>
                <div className="hero-content">
                  <h1 className="hero-title">{slide.title}</h1>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Arrows */}
          {slides.length > 1 && (
            <>
              <button className="hero-arrow hero-arrow-left" onClick={prevSlide}>
                <span>‹</span>
              </button>
              <button className="hero-arrow hero-arrow-right" onClick={nextSlide}>
                <span>›</span>
              </button>
            </>
          )}

          {/* Slide Indicators */}
          {slides.length > 1 && (
            <div className="hero-indicators">
              {slides.map((_, index) => (
                <button
                  key={index}
                  className={`hero-indicator ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                />
              ))}
            </div>
          )}

        </div>
      </div>
    </section>
  );
};

export default Hero;
